import { AbridgedAsset, AssetsFilter } from 'store/assets/types';
import { OrganisationListItem } from 'store/organisations/types';

export interface SearchFilters extends AssetsFilter {
  exclude_assets: string[];
}

export type PartialSearchFilters = Partial<SearchFilters>;

export type SearchRequest = {
  limit: number;
  offset: number;
  filter: SearchFilters;
  sort: string;
};

export interface SearchOption {
  id: string;
  name: string;
}

export interface SearchFilterOption extends SearchOption {
  colour?: string;
}

interface SearchFilter {
  type: string;
  title: string;
  items: SearchFilterOption[];
}

export type SearchOptions = {
  sort: SearchOption[];
  filter: Record<string, SearchFilter>;
};

export type SearchResults = {
  assets: Record<string, AbridgedAsset>;
  asset_ids: string[];
  organisations: Record<string, OrganisationListItem>;
  total: number | null;
};

export enum SearchStatus {
  none,
  searching,
}

export interface SearchState {
  opened: boolean;
  error?: string;
  status: SearchStatus;
  options: SearchOptions;
  results: SearchResults;
  request: SearchRequest;
  lastGoodRequest: SearchRequest;
  chosen: string[];
}
